import "./HeroTitle.css"

function HeroTitle (props) {
    return ( 
        <div className="hero-section">
            <h1>{props.title}</h1>
          <div className="hero-decoration"></div>
        </div>
    )
}

export default HeroTitle;